import axios from "axios";
import { config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Add New User (Register)
export const add_user = async (values: FormData) => {
    let response = await axios.post(baseURL + "/register", values, config_multipart);
    return response.data;
}

// Get All Users
export const get_all_users = async () => {
    let response = await axios.get(baseURL + '/get-users');
    return response.data;
}

// Get Single User Data
export const get_user_data = async (user_id: number) => {
    let response = await axios.get(baseURL + `/get-user-data/${user_id}`);
    return response.data;
}

// Update User
export const update_user = async (user_id: number, formdata: FormData) => {
    let response = await axios.post(baseURL + `/user-update/${user_id}`, formdata, config_multipart);
    return response.data;
}

// Delete User
export const delete_user = async (user_id: number) => {
    let response = await axios.delete(baseURL + `/users/${user_id}`);
    return response.data;
}

// Get All Active Users
export const get_active_users = async () => {
    let response = await axios.get(baseURL + '/get-active-users');
    return response.data;
}

// Get Current User
export const get_current_user = async () => {
    let response = await axios.get(baseURL + '/user/');
    return response.data;
}

// Get All User Logs
export const get_all_users_logs = async () => {
    let response = await axios.get(baseURL + '/all-user-logs');
    return response.data;
}

// Get Single User Log
export const get_single_user_log = async (id: number) => {
    let response = await axios.get(baseURL + `/single-user-log/${id}`);
    return response.data;
}